import { defineStore } from "pinia";
import {
  BlockContent,
  IBlockTranslation,
  RichTextModuleData,
  BlockSliderContent,
} from "ecom-types";
interface State {
  footer: {
    copyright: string | undefined;
    leftColumn: BlockContent | undefined;
    rightColumn: string | undefined;
    centerColumn: string | undefined;
    certificatesEntities: RichTextModuleData | null | undefined;
    bottomInfo: RichTextModuleData | null | undefined;
  };
  isSignInDrawerOpen: boolean;
  isSignUpDrawerOpen: boolean;
  systemData: {
    loginFooter: RichTextModuleData | null;
  };
  systemOverlay: boolean;
  systemLoader: boolean;
  topPromotion: BlockSliderContent | null | undefined;
}

export const useGeneralInternalStore = defineStore("generalInternal", {
  state: (): State => ({
    footer: {
      copyright: "",
      leftColumn: undefined,
      rightColumn: "",
      centerColumn: "",
      certificatesEntities: null,
      bottomInfo: null,
    },
    isSignInDrawerOpen: false,
    isSignUpDrawerOpen: false,
    systemData: {
      loginFooter: null,
    },
    systemOverlay: false,
    systemLoader: false,
    topPromotion: null,
  }),

  actions: {
    async getBlocks() {
      const { $api } = useNuxtApp();
      const { data: apiData } = await useAsyncData(
        "getBaseBlocks",
        async () => {
          const [
            responseCopyright,
            responseFooterLeftColumn,
            responseSystemLoginFooter,
            responseTopBanner,
          ] = await Promise.all([
            $api.blocks.getBlock("footer-copyright"),
            $api.blocks.getBlock("footer-left-column"),
            $api.blocks.getBlock("system-login-footer"),
            $api.blocks.getBlock("site-advertisement-slider"),
          ]);

          return {
            dataCopyright: responseCopyright.data,
            dataFooterLeftColumn: responseFooterLeftColumn.data,
            dataSystemLoginFooter: responseSystemLoginFooter.data,
            dataTopBanner: responseTopBanner.data,
          };
        },
      );

      const {
        dataCopyright,
        dataSystemLoginFooter,
        dataFooterLeftColumn,
        dataTopBanner,
      } = apiData.value || {};

      this.footer.copyright =
        (dataCopyright?.currentTranslation as IBlockTranslation<BlockContent>)
          ?.content?.content || "";

      this.systemData.loginFooter =
        ((
          dataSystemLoginFooter?.currentTranslation as IBlockTranslation<BlockContent>
        )?.content as RichTextModuleData) || "";

      this.footer.leftColumn =
        (
          dataFooterLeftColumn?.currentTranslation as IBlockTranslation<BlockContent>
        )?.content || "";

      this.topPromotion =
        (
          dataTopBanner?.currentTranslation as IBlockTranslation<BlockSliderContent>
        )?.content || null;
    },
  },
});
